<template>
  <FormWrapper :handleSubmit="submit" :loading="loading">
    <template #default>
      <b-row class="margin-0">
        <b-col cols="12" class="padding-0">
          <div class="font-size-14 color-complementary-400 margin-bottom-16">
            {{ $lang.termAttachmentsLabel }}
            (<span class="color-complementary-200">{{ $lang.optional }}</span
            >)
          </div>
        </b-col>
        <b-col cols="12" class="padding-0 flex-between">
          <EnumDropdown
            :title="$lang.selectOption"
            :label="$lang.selectOption"
            :placeholder="$lang.selectOption"
            :value="form.attachmentType"
            name="attachmentType"
            id="attachmentType"
            categoryName="attachment_type_person"
            class="width-percent-100"
            :vuelidateObj="$v.form.attachmentType"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <Button
            wrapperClass="margin-top-8 margin-right-8"
            contentClass="justify-content-center"
            variant="complementary"
            justIcon="plus"
            @click="addAttachment"
          />
        </b-col>
        <b-col
          v-for="(item, index) in generateItems"
          :key="`a-${index}`"
          cols="12"
          class="padding-16 border--solid border--complementary-50 border-radius-8 margin-bottom-16"
        >
          <Switchbox
            :label="item.caption"
            :value="item.isRequired"
            :name="item.id"
            boxClass="flex-between"
            :showStateText="true"
            :checkedStateText="$lang.required"
            :uncheckedStateText="$lang.required"
            @input="changeIsRequired"
          />
          <Dropdown
            :label="$lang.maxUploadSizeLabel"
            :placeholder="$lang.maxUploadSizeLabel"
            :value="item.maxUpload"
            :name="item.id"
            :id="`item-${item.id}`"
            :options="numberOptions"
            rowClass="margin-bottom-8"
            @input="changeMaxUpload"
          />
          <div class="flex-end">
            <Button
              contentClass="justify-content-center"
              variant="complementary"
              :text="$lang.remove"
              size="sm"
              @click="removeAttachment(item.id)"
            />
          </div>
        </b-col>
      </b-row>
    </template>
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  FormWrapper,
  EnumDropdown,
  Button,
  Switchbox,
  Dropdown,
} from "@/components/re-design/forms";
import { pathOr } from "ramda";
import { toastAlert } from "@/shared/utils";
import { editTermExtraAttachment } from "@/modules/profile/services";
export default {
  mixins: [inputMixin],
  inject: ["TERM_CODE", "TERM_DATA"],
  components: { FormWrapper, EnumDropdown, Button, Switchbox, Dropdown },
  validations() {
    return {
      form: {
        attachmentType: {},
      },
    };
  },
  data() {
    return {
      form: {
        attachmentType: null,
      },
      items: [],
      loading: false,
    };
  },
  computed: {
    generateItems() {
      return this.items.map((item) => {
        const maxUpload = {
          id: item.max_upload,
          caption: `${item.max_upload} عدد`,
        };
        return {
          id: item.id,
          caption: item.caption || `عنوان ${item.id}`,
          isRequired: item.is_required,
          maxUpload,
        };
      });
    },
    numberOptions() {
      const items = [];
      for (let id = 1; id <= 20; id++) {
        items.push({
          id,
          caption: `${id} عدد`,
        });
      }
      return items;
    },
  },
  watch: {
    TERM_DATA: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchData(value);
        }
      },
    },
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const termCode = this.TERM_CODE;
        const response = await editTermExtraAttachment(termCode, this.items);
        const { message } = response;
        this.$notify.success(message);
        this.$emit("getTermData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    fetchData(data) {
      this.items = [...pathOr([], ["extra_fields", "attachment"], data)];
    },
    changeIsRequired(name, value) {
      const newItems = this.items.map((item) => {
        const isRequired = item.id === name ? value : item.is_required;
        return { ...item, is_required: isRequired };
      });
      this.items = [...newItems];
    },
    changeMaxUpload(name, value) {
      const { id } = value;
      const newItems = this.items.map((item) => {
        const maxUpload = item.id === name ? id : item.max_upload;
        return { ...item, max_upload: maxUpload };
      });
      this.items = [...newItems];
    },
    addAttachment() {
      if (!this.form.attachmentType) {
        return toastAlert(this.$lang.pleaseSelectOneOption, "warning");
      }

      const { id, caption } = this.form.attachmentType;

      const alreadySelected = this.items.some((item) => item.id === id);
      if (alreadySelected) {
        this.resetForm();
        return toastAlert(this.$lang.alreadyExist, "warning");
      }

      const newItem = {
        id,
        caption,
        is_required: true,
        max_upload: 1,
      };
      this.items.unshift(newItem);
      this.resetForm();
    },
    removeAttachment(id) {
      this.items = this.items.filter((item) => item.id !== id);
    },
  },
};
</script>
